import { createAction, props } from '@ngrx/store';

import { SoilType } from '../soil-type.model';

export const getSoilTypes = createAction('[Soil type] Get soil types');

export const setSoilTypes = createAction(
  '[Soil type] Set soil types',
  props<{ soilTypes: SoilType[] }>(),
);
